import { getLocale } from 'services/helpers/locale';

import { LanguageState } from './types';

export const languageInitialState: LanguageState = {
  currentLanguage: getLocale(),
};
